module.exports = __webpack_public_path__ + "static/tubzz-91bedd5f6f42dba0c9828053efa8618a.jpg";